import { cx } from '@flowus/common/cx';
import type { CSSProperties, FC } from 'react';
import { Icon } from 'src/common/components/icon';
import { Tooltip } from 'src/common/components/tooltip';
import { ActivityIds } from 'src/hooks/activities/activity-ids';
import { ActivitiesListType } from 'src/hooks/activities/use-activity';
import { useUpdateTask } from 'src/hooks/activities/use-update-task';
import { useTransaction } from 'src/hooks/use-transaction';
import { useIsFavoritePage } from 'src/hooks/user';
import * as FavoriteManager from 'src/redux/managers/favorite';
import { $currentUserCache } from 'src/services/user/current-user';
import { bizTracker } from 'src/utils/biz-tracker';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const Favorite: FC<{ uuid: string; style?: CSSProperties; className?: string }> = ({
  uuid,
  style,
  className,
}) => {
  const { t } = useAppTranslation();
  const updateTask = useUpdateTask();
  const isFavorite = useIsFavoritePage(uuid);
  const transaction = useTransaction();

  return (
    <Tooltip
      popup={isFavorite ? t('common.cancel_quick_access') : t('common.add_to_quick_access')}
      className={cx('p-1 flex items-center justify-center animate-hover flex-shrink-0', className)}
      onClick={() => {
        if (isFavorite) {
          bizTracker.event('favorite_cancel_pageclick');
        } else {
          bizTracker.event('favorite_pageclick');
        }
        transaction(() => {
          isFavorite
            ? FavoriteManager.remove(uuid, {
                parentId: $currentUserCache.currentSpaceViewId,
              })
            : FavoriteManager.add(uuid, {
                first: true,
                parentId: $currentUserCache.currentSpaceViewId,
              });
        });

        if (!isFavorite) {
          void updateTask(ActivityIds.ADD_TO_FAVORITE, ActivitiesListType.advancedList);
        }
      }}
    >
      <Icon
        name={isFavorite ? 'IcQuickAccess' : 'IcQuickAccess'}
        size="middle"
        style={style}
        className={cx(isFavorite && 'text-yellow')}
      />
    </Tooltip>
  );
};
